import { render, staticRenderFns } from "./demandorder.vue?vue&type=template&id=7b3039aa&"
import script from "./demandorder.vue?vue&type=script&lang=js&"
export * from "./demandorder.vue?vue&type=script&lang=js&"
import style0 from "./demandorder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports